import React, { useEffect, useState, useRef } from "react";

import {
  Alert,
  Select,
  MenuItem,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Grid2,
  FormGroup,
  FormControlLabel,
  Typography,
  FormControl,
  FormHelperText,
  Checkbox,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import constants from "../static/constants.json";
import { addProperty, editProperty } from "../redux/userSlice";
import { PropertiesAPI } from "../apis/propertiesAPI";
import { mainButtonStyle } from "../static";
type PropertiesDialogProps = {
  property: any;
  open: boolean;
  handleClose: () => void;
};

const PropertiesDialog = ({
  property,
  open,
  handleClose,
}: PropertiesDialogProps) => {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch();
  const [typeId, setTypeId] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [access, setAccess] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [squareft, setSquareFeet] = useState("");
  const [acres, setAcreage] = useState("");
  const [addingPhoto, setAddingPhoto] = useState(false);
  const [address, setAddress] = useState({} as any);
  const [defaultTasks, setDefaultTasks] = useState([] as any);

  const tasks = useSelector((state: any) => state.tasks.list);

  const addDefaultTask = (taskId: string, isEnabled: boolean) => {
    let newTasks = [...defaultTasks];
    console.log("new tasks is ", newTasks);
    console.log("clicked", taskId, isEnabled);
    if (isEnabled && newTasks.indexOf(taskId) < 0) {
      newTasks.push(taskId);
    } else if (!isEnabled && newTasks.indexOf(taskId) > -1) {
      newTasks.splice(newTasks.indexOf(taskId), 1);
      // let a = newTasks.filter(t => t.id === taskId);
      // newTasks = a;
    }
    console.log("now ", newTasks);
    setDefaultTasks(newTasks);
  };

  const saveProperty = async () => {
    // TODO validate inputs
    const currErrs = {} as any;

    if (Object.keys(currErrs).length === 0) {
    }

    const body = {
      typeId,
      address,
      bedrooms,
      bathrooms,
      access,
      squareft,
      acres,
      defaultTasks,
    } as any;

    if (property.id) {
      body.id = property.id;
      try {
        const j = await PropertiesAPI.updateProperty(body);
        dispatch(editProperty(j));
        setMsg("Property Updated");
        setShowMsg(true);
        handleClose();
      } catch (e) {
        alert(e);
      }
    } else {
      try {
        const j = await PropertiesAPI.createProperty(body);
        dispatch(addProperty(j));
        setMsg("Property Created");
        setShowMsg(true);
        handleClose();
      } catch (e) {
        alert(e);
      }
    }
  };

  const setAddressField = (fieldName: string, value: string) => {
    const newAddr = { ...address };
    newAddr[fieldName] = value;
    setAddress(newAddr);
  };

  useEffect(() => {
    if (property.id) {
      setTypeId(property.type.id);
      setAddress(property.address);
      setDefaultTasks(property.defaultTasks);
      setSquareFeet(property.squareft);
      setAcreage(property.acres);
      setAccess(property.access);
      setBedrooms(property.bedrooms);
      setBathrooms(property.bathrooms);
    } else {
      setAddress({});
      setTypeId("");
    }
  }, [property]);

  const closeDialog = () => {
    handleClose();
  };

  const optionItemStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // border: '1px solid red'
  };

  const textFieldStyle1 = {
    width: "100%",
  };
  return (
    <>
    <Dialog
        open={addingPhoto}
        onClose={() => setAddingPhoto(false)}
        
      >
        <DialogContent>
        <input 
        ref={fileInput} 
        type="file"
        accept="image/* .heic" 
        style={{ display: 'none' }} 
        onChange={(e) => {
          console.log('e is ', e);
        }}
      />
        </DialogContent>

<DialogActions>
    <Button onClick={()=>fileInput.current?.click()}>Upload from device</Button>
    <Button>Take Photo</Button>

</DialogActions>
      </Dialog>
      {/* <CameraDrawer
        open={showDrawer}
        onClose={() => {
          setShowDrawer(false);
        }}
        onPhotoTaken={(photo: string) => {
          addPhoto(photo);
          setShowDrawer(false);
        }}
      /> */}
      <Snackbar
        open={showMsg}
        autoHideDuration={6000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        onClose={closeDialog}
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>
          {property && property.id ? "Edit Property" : "New Property"}
        </DialogTitle>
        <DialogContent>
          <Grid2 container spacing={3}>
            <Grid2 size={12}>
              <DialogContentText>
                {property && property.id
                  ? ""
                  : "To add a property, fill out this form."}
              </DialogContentText>
            </Grid2>
            <Grid2 size={12} style={{}}>
              <Typography style={{ fontWeight: "700" }}>Details</Typography>
            </Grid2>
            <Grid2 size={12}>
              <Select
                value={typeId}
                onChange={(e) => setTypeId(e.target.value)}
                fullWidth
                style={{ width: "100%" }}
                // placeholder="Property Type"
                label="Property Type"
              >
                <MenuItem value={constants.propertyType.house}>House</MenuItem>
                <MenuItem value={constants.propertyType.apartment}>
                  Apartment
                </MenuItem>
              </Select>
            </Grid2>
            <Grid2 size={3} style={{}}>
              <TextField
                style={textFieldStyle1}
                value={bedrooms}
                onChange={(e) => setBedrooms(e.target.value)}

                label="Bedrooms"
                slotProps={{inputLabel: { shrink: true }}}
                type="number"
              />
            </Grid2>
            <Grid2 size={3} style={{}}>
              <TextField
                style={textFieldStyle1}
                value={bathrooms}
                onChange={(e) => setBathrooms(e.target.value)}

                label="Bathrooms"
                slotProps={{inputLabel: { shrink: true }}}
                type="number"
              />
            </Grid2>
            <Grid2 size={3} style={{}}>
              <TextField
                style={textFieldStyle1}
                value={squareft}
                onChange={(e) => setSquareFeet(e.target.value)}

                slotProps={{inputLabel: { shrink: true }}}
                label="Square Feet"
                type="number"
              />
            </Grid2>
            <Grid2 size={3} style={{}}>
              <TextField
                style={textFieldStyle1}
                value={acres}
                onChange={(e) => setAcreage(e.target.value)}

                slotProps={{inputLabel: { shrink: true }}}
                  label="Acres"
                type="number"
              />
            </Grid2>
            <Grid2 size={12} style={{}}>
              <Typography style={{ fontWeight: "700" }}>Address</Typography>
            </Grid2>

            <Grid2 size={12} style={optionItemStyle}>
              <TextField
                style={textFieldStyle1}
                value={address.street1}
                onChange={(e) => setAddressField("street1", e.target.value)}
                placeholder="Street Line 1"
              />
            </Grid2>
            <Grid2 size={12} style={optionItemStyle}>
              <TextField
                value={address.street2}
                style={textFieldStyle1}
                onChange={(e) => setAddressField("street2", e.target.value)}
                placeholder="Street Line 2"
              />
            </Grid2>
            <Grid2 size={4} style={optionItemStyle}>
              <TextField
                value={address.city}
                style={textFieldStyle1}
                onChange={(e) => setAddressField("city", e.target.value)}
                placeholder="City"
              />
            </Grid2>
            <Grid2 size={4} style={optionItemStyle}>
              <TextField
                style={textFieldStyle1}
                value={address.state}
                onChange={(e) => setAddressField("state", e.target.value)}
                placeholder="State"
              />
            </Grid2>
            <Grid2 size={4} style={optionItemStyle}>
              <TextField
                type="number"
                style={textFieldStyle1}
                value={address.zip}
                onChange={(e) => setAddressField("zip", e.target.value)}
                placeholder="Zip"
              />
            </Grid2>

            <Grid2 size={12} style={{}}>
              <Typography style={{ fontWeight: "700" }}>
                Access Instructions
              </Typography>
            </Grid2>

            <Grid2 size={12} style={optionItemStyle}>
              <FormControl sx={{ width: "100%" }} variant="filled">
                <TextField
                  style={textFieldStyle1}
                  value={access}
                  onChange={(e) => setAccess(e.target.value)}
                  placeholder="e.g. Lock Code 1234"
                  multiline
                />
                <FormHelperText id="filled-weight-helper-text">
                  Workers can see access instructions when the job starts
                </FormHelperText>
              </FormControl>
            </Grid2>
            <Grid2 size={12} style={{}}>
              <Typography style={{ fontWeight: "700" }}>
                Default Tasks
              </Typography>
            </Grid2>

            <Grid2 size={6} style={{}}>
              <Typography style={{ fontWeight: "700" }}>Cleaning</Typography>
              <FormGroup>
                {tasks
                  .filter(
                    (t: any) => t.jobTypeId === constants.jobType.cleaning
                  )
                  .map((t: any) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={defaultTasks.indexOf(t.id) > -1}
                          onChange={(e) => {
                            addDefaultTask(t.id, e.target.checked);
                          }}
                        />
                      }
                      label={t.name}
                    />
                  ))}
              </FormGroup>
            </Grid2>
            <Grid2 size={6} style={{}}>
              <Typography style={{ fontWeight: "700" }}>Landscaping</Typography>
              <FormGroup>
                {tasks
                  .filter(
                    (t: any) => t.jobTypeId === constants.jobType.landscaping
                  )
                  .map((t: any) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={defaultTasks.indexOf(t.id) > -1}
                          onChange={(e) => {
                            addDefaultTask(t.id, e.target.checked);
                          }}
                        />
                      }
                      label={t.name}
                    />
                  ))}
              </FormGroup>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" style={mainButtonStyle} onClick={() => {
            setAddingPhoto(true)
          }}>Add Photo</Button>
          <Button style={mainButtonStyle} onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            style={mainButtonStyle}
            onClick={() => {
              saveProperty();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PropertiesDialog;
